import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';

const parts = [
'abgeordnete-1',
'abgeordnete',
'einwanderbehoerde',
'finanzamt',
'gericht',
'landtag',
'landtagspraesident',
'ministerpreaesident',
'polizei',
'regierung_ab',
'richter',
'staatskanzlei',
'staatsministerin',
'vizepraesident'
]

export class gamePower extends cDisplay {

  private dropTargtes:cSprite[]
  private items:number[]
  private score: number 
  private complted:any
  private textData: any

  private current: cSprite

  private glow:any

  init(){
    super.init()
    console.log('GAME gamePower')
    var cS:cScene = this.scene as cScene;

    this.current = null

    this.items = []
    for (var a=0; a < parts.length;a++){
      this.items.splice(Phaser.Math.RND.between(0,this.items.length),0,a );
    }
        
    
    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      switch (b.command){
        case 'handle_drop':
          var [raw,num] = String(b.payload.tg).split('_');
          var idx = parts[ Number(num)-1 ]
          if (idx){
            this.current.modules.drag.enabled = false;
            cS.triggerSceneEvent('info',{info: this.textData[idx],title:'Stimmt!' })
          }else{
            this.current.modules.drag.returnToOrigin()
            this.glow.visible = true
          }
          break;
        case 'handle_drag_start':
          this.glow.visible = false
          break;
        case 'create':          
          if (this.items.length === 0 ){
            cS.triggerSceneEvent('done')
            return
          }
          var n = this.items.pop();
          var s = new cSprite(cS,{
            name:'',
            asset:'parts',
            frame: parts[n],
            ofs:'[center]x[center]',
            id:'$',
            type:'',
            dragtarget: `tg_${n+1}`,
            animpreset:'popup'
          });
          
          (cS.getByName('dragitem') as cContainer).add(s)
          this.glow.visible = true
          this.current = s
          break;
      }
    })
  }

  buildScene(){    
    super.buildScene();

    var d:cContainer = this.getByName('DATA')
    this.textData = d.modules.data._extraData

    this.glow = this.getByName('glow_star')
    console.log(this.textData)
  }



}
